'use strict';
const angular = require('angular');

export class photoCardComponent {
  /*@ngInject*/
  constructor() {
  }
}

export default angular.module('conduuApp.photoCard', [])
  .component('photoCard', {
    template: require('./photo-card.component.html'),
    bindings: {
      photo: '@'
    },
    controller: photoCardComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/photo-card/photo-card.component.js